module.exports = __webpack_public_path__ + "static/media/buddy_read.e0d8d120.webp";